import { isNil } from 'lodash';
import ordinal from 'ordinal';

import { GRADUATED_GRADE, STUDENT_SCOPE } from 'constants/gradeYears';
import { EL } from 'routes/constants';

export const getGradeName = ({
  grade,
  isLongVariant = false,
  useShortKindergarten = false,
  noOrdinal = false,
}) => {
  if (grade === 0) {
    return useShortKindergarten ? 'K' : 'Kindergarten';
  }
  if (grade === GRADUATED_GRADE) {
    return 'Alumni';
  }
  if (isNil(grade)) {
    return 'N/A';
  }
  return `${noOrdinal ? grade : ordinal(grade)}${
    isLongVariant ? ' Grade' : ''
  }`;
};

export const getUrlPrefix = studentScope =>
  studentScope === STUDENT_SCOPE.ELEMENTARY ? EL : '';
